import React, { useEffect, useState } from 'react'
import { Layout, Menu } from 'antd';
import {Link, useLocation} from 'react-router-dom';
import { useSelector } from 'react-redux';
const { Sider } = Layout;
export const SideBar=({ collapsed, items })=> {
  const auth = useSelector(state => state.auth)
 // console.log(auth.user.role)
 const [selectedKeys, setselectedKeys] = useState("1")
  const location = useLocation()
  useEffect(() => {
    items.map((item) => {
     if(location.pathname.includes(item.path.slice(0, -1))){
      setselectedKeys(item.key);
     }})
  }, [location])
  return (
    <Sider trigger={null} collapsible collapsed={collapsed}>
      <div className="logo" />
      <Menu theme="dark" mode="inline" selectedKeys={[selectedKeys]} defaultSelectedKeys={[selectedKeys]}>
        {
          items.map((item) => {
            return (
              <Menu.Item key={item.key} icon={item.icon}>
               <Link to={item.path}>
               {item.title}
               </Link> 
              </Menu.Item>
              )

          })
        }
      </Menu>
    </Sider>
  )

}

export default SideBar
